module.exports = __webpack_public_path__ + "static/media/L.16472bd2.jpg";